import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Kpi } from "../components/Kpi";
import Leaderboard from "../components/Leaderboard";
import { useNavigate } from "react-router-dom";
import { Card } from "../components/ui/card";

export default function Dashboard() {
  const [data, setData] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/dashboard/summary").then(r => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <div className="text-muted-foreground">Loading dashboard…</div>;
  const k = data.kpis;

  return (
    <div className="space-y-8 animate-in">
      <div>
        <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Command Center</div>
        <h1 className="font-serif-display text-4xl mt-1">Today at GRAM</h1>
        <p className="text-sm text-muted-foreground mt-1">Live picture of leads, visits, and pipeline — across Mandate, Retail and Home Loan.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        <Kpi label="New Leads Today" value={k.today_leads} sub={`${k.total_leads} total`} onClick={() => nav("/leads")} testId="kpi-today-leads"/>
        <Kpi label="Qualified" value={k.qualified} sub={`${k.lead_to_visit_pct}% → visit`} onClick={() => nav("/leads")} testId="kpi-qualified"/>
        <Kpi label="Visits Today" value={k.visits_today} sub={`${k.total_visits} total • ${k.visits_completed} done`} onClick={() => nav("/visits")} testId="kpi-visits-today"/>
        <Kpi label="Bookings" value={k.bookings} sub={`${k.visit_to_booking_pct}% visit→book`} onClick={() => nav("/bookings")} testId="kpi-bookings"/>
        <Kpi label="Overdue Follow-ups" value={k.overdue_followups} sub="Requires action" onClick={() => nav("/leads")} testId="kpi-overdue"/>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Kpi label="Active CPs" value={k.active_cps} sub={`${k.obms} OBM • ${k.ibms} IBM`} onClick={() => nav("/cps")} testId="kpi-cps"/>
        <Kpi label="Lead → Visit" value={`${k.lead_to_visit_pct}%`} sub="Conversion" testId="kpi-lv"/>
        <Kpi label="Visit → Booking" value={`${k.visit_to_booking_pct}%`} sub="Conversion" testId="kpi-vb"/>
        <Kpi label="Lead → Booking" value={`${k.lead_to_booking_pct}%`} sub="End-to-end" testId="kpi-lb"/>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-6" data-testid="funnel-card">
          <div className="text-[11px] uppercase tracking-widest text-muted-foreground">Sales Funnel</div>
          <div className="mt-4 space-y-2">
            {data.funnel.map(row => {
              const max = Math.max(...data.funnel.map(f => f.count), 1);
              const pct = Math.round((row.count / max) * 100);
              return (
                <div key={row.stage} className="flex items-center gap-3">
                  <div className="w-40 text-xs uppercase tracking-wider text-muted-foreground">{row.stage.replace(/_/g, " ")}</div>
                  <div className="flex-1 h-6 bg-secondary rounded relative overflow-hidden">
                    <div className="h-full bg-accent/70" style={{ width: `${pct}%` }}></div>
                  </div>
                  <div className="metric-value w-12 text-right">{row.count}</div>
                </div>
              );
            })}
          </div>
        </Card>
        <Card className="p-6" data-testid="source-card">
          <div className="text-[11px] uppercase tracking-widest text-muted-foreground">Leads by Source</div>
          <div className="mt-4 grid grid-cols-2 gap-3">
            {data.by_source.map(r => (
              <div key={r.source} className="flex items-center justify-between border-b border-border py-2">
                <span className="text-sm capitalize">{r.source.replace(/_/g, " ")}</span>
                <span className="metric-value">{r.count}</span>
              </div>
            ))}
          </div>
        </Card>
      </div>

      <Leaderboard />

      <Card className="p-6">
        <div className="text-[11px] uppercase tracking-widest text-muted-foreground">Leads by Project</div>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-3">
          {data.by_project.map(r => (
            <div key={r.project_id || "none"} className="flex items-center justify-between border border-border rounded-md px-4 py-3">
              <span className="text-sm">{r.project_name}</span>
              <span className="metric-value text-lg">{r.count}</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
